import { z } from "zod";

export const passwordResetPetitionSchema = z.object({
  email: z.string().min(1, "Email is required").email("Please enter a valid email address"),
});
